import { Stack, Typography } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

interface INoMeetingMessage {
  text: string;
}

export const NoMeetingMessage: React.FC<INoMeetingMessage> = (props) => {
  return (
    <Stack sx={{ marginTop: '24px' }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{ backgroundColor: '#FFFFFF', padding: '24px', borderRadius: '4px', border: '1px solid #dddddd' }}
      >
        <CheckCircleOutline /> <Typography>{props.text}</Typography>
      </Stack>
    </Stack>
  );
};
